import { SelectionList, SelectionListGroup } from '../offer-select.types';

export interface FixedItemData {
  title: string;
  emptyStateTitle: string;
  sortable: boolean;
}

export interface ItemData extends FixedItemData {
  itemGroups: SortingGroup[];
}

export type ListData = Partial<GroupedSelectionItems<SelectionList[]>>;

export interface GroupedSelectionItems<T> {
  [SelectionListGroup.Job]: T;
  [SelectionListGroup.TalentPool]: T;
  [SelectionListGroup.JobTemplate]: T;
}

export enum SortOptions {
  Department = 'department',
  Location = 'location',
  Status = 'status',
  Title = 'title',
  Country = 'country',
}

export type SortOptionsType =
  | SortOptions.Department
  | SortOptions.Country
  | SortOptions.Location
  | SortOptions.Status
  | SortOptions.Title;

export type SortingGroup = {
  groupTitle?: string;
  items: SelectionList[];
  key?: string;
};
